<script>
import { mapGetters } from 'vuex'
import TagImage from '@/components/organism/restaurants/TagImage'
import Swiper from '@/components/molecules/Swiper'
export default {
    name: 'TagSelect',
    components: { Swiper, TagImage },
    computed: {
        ...mapGetters({
            tags: 'tags/featured',
            loaded: 'tags/loaded',
        }),

        hasActiveCanteen() {
            return !!this.$store.getters['active/canteen']?.id
        },

        selectedTag: {
            get() {
                return this.$route.query.tag_name ? this.$route.query.tag_name : undefined
            },
            set(val) {
                this.setQuery({ tag_name: val ? val : undefined }, 'restaurant-list', {
                    pageLoader: false,
                })
            },
        },
    },
}
</script>

<template lang="pug">
swiper.tag-select(:loaded="loaded")
    tag-image(
        v-for="(tag, index) in tags"
        :key="`tag-${index}`"
        v-model="selectedTag"
        :disabled="hasActiveCanteen"
        :tag="tag")
</template>
